import defaultStyles from './googleMapStyles.json';

export default defaultStyles;
// This file can be used to customize the map styles.
